module.exports = __webpack_public_path__ + "img/行业管理.31ec831a.png";